import { Segment, Header, Grid, Menu, Dropdown } from "semantic-ui-react";
import AdminInvoiceItemsGrid from "./AdminInvoiceItemsGrid";
import { InvoiceItem } from "../models/InvoiceItem";
import { Organization } from "../models/Organization";
import { AsyncActionStatus } from "../models/AsyncActionStatus";
import { useEffect } from "react";
import { toastSuccess } from "../utils";

interface Props {
  isInvoiceItemsLoading: boolean;
  invoiceItems?: InvoiceItem[] | null;
  organizations?: Organization[] | null;
  pageCount?: number;
  onPageInfoChange: (pageSize: number, pageIndex: number) => void;
  onOrgFilter: (orgId: string) => void;
  onInvoiceItemSelectChange: (id: string, checked: boolean) => void;
  selectedInvoiceItems: string[];
  onMarkAsSent: () => void;
  markInvoiceItemsAsSentStatus: AsyncActionStatus;
}

const AdminInvoiceItemsList = ({
  isInvoiceItemsLoading,
  invoiceItems,
  organizations,
  pageCount,
  onPageInfoChange,
  onOrgFilter,
  onInvoiceItemSelectChange,
  selectedInvoiceItems,
  onMarkAsSent,
  markInvoiceItemsAsSentStatus,
}: Props) => {
  const handleOrgFilterChange = (e: any, { name, value }: any) => {
    onOrgFilter(value === "" ? null : value);
  };

  useEffect(() => {
    if (markInvoiceItemsAsSentStatus.successful) {
      toastSuccess("Invoice item(s) marked as sent successfully!");
    }
  }, [markInvoiceItemsAsSentStatus.successful]);

  return (
    <>
      <Segment basic>
        <Header as="h2">Invoice items</Header>
      </Segment>

      <Menu pointing secondary color="green">
        <Menu.Item disabled={!(selectedInvoiceItems.length > 0)} onClick={onMarkAsSent}>
          Mark as sent
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <Dropdown
              placeholder="Organization"
              basic
              clearable
              onChange={handleOrgFilterChange}
              options={organizations?.map((o) => ({ key: o.id, text: o.name, value: o.id }))}
            ></Dropdown>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Segment basic loading={isInvoiceItemsLoading}>
        <Grid columns="1">
          <Grid.Row>
            <Grid.Column width="16">
              <AdminInvoiceItemsGrid
                invoiceItems={invoiceItems}
                pageCount={pageCount}
                onPageInfoChange={onPageInfoChange}
                onInvoiceItemSelectChange={onInvoiceItemSelectChange}
                selectedInvoiceItems={selectedInvoiceItems}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </>
  );
};

export default AdminInvoiceItemsList;
